/* eslint-disable */
import classNames from 'classnames';
import ErrorIcon from 'images/info-circle-red.svg';
import ChevIcon from 'images/v5/icons/chevron-right.svg';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import styles from './Tabs.module.scss';
const Tabs = ({ size = 'm', tabs, activeTab, onClick }) => {
    const contentRef = useRef(null);
    const wrapRef = useRef(null);
    const params = useParams();
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const handleOnClick = (id) => {
        onClick(id);
    };
    const handleScrollToEnd = () => {
        if (contentRef.current) {
            contentRef.current.scrollTo({
                left: contentRef.current.scrollWidth,
                behavior: 'smooth',
            });
        }
    };
    const handleScrollToStart = () => {
        if (contentRef.current) {
            contentRef.current.scrollTo({
                left: 0,
                behavior: 'smooth',
            });
        }
    };
    const checkScrollPosition = () => {
        if (!contentRef.current || !wrapRef.current)
            return;
        const { scrollLeft, scrollWidth, clientWidth } = contentRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    };
    useEffect(() => {
        checkScrollPosition();
        const handleResize = () => checkScrollPosition();
        const scrollEl = contentRef.current;
        scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.addEventListener('scroll', checkScrollPosition);
        window.addEventListener('resize', handleResize);
        return () => {
            scrollEl === null || scrollEl === void 0 ? void 0 : scrollEl.removeEventListener('scroll', checkScrollPosition);
            window.removeEventListener('resize', handleResize);
        };
    }, [tabs]);
    return (React.createElement("div", { className: classNames(styles.wrap, styles[size]), ref: wrapRef },
        canScrollLeft && (React.createElement("button", { className: classNames(styles.scrollButton, styles.left), onClick: handleScrollToStart },
            React.createElement(ChevIcon, null))),
        React.createElement("div", { className: classNames(styles.content, styles[size]), ref: contentRef }, tabs.map((tab, index) => (React.createElement("button", { key: index, className: classNames(styles.tab, styles[size], {
                [styles.active]: tab.id === activeTab || tab.id === params.tab,
            }), onClick: () => handleOnClick(tab.id) },
            tab.icon && tab.icon,
            tab.label,
            tab.error && React.createElement(ErrorIcon, null),
            tab.counter && React.createElement("span", { className: styles.counter }, tab.counter))))),
        canScrollRight && (React.createElement("button", { className: classNames(styles.scrollButton, styles.right), onClick: handleScrollToEnd },
            React.createElement(ChevIcon, null)))));
};
export default Tabs;
